import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=29c1299c&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=29c1299c&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c1299c')) {
      api.createRecord('29c1299c', component.options)
    } else {
      api.reload('29c1299c', component.options)
    }
    module.hot.accept("./DonutChart.vue?vue&type=template&id=29c1299c&", function () {
      api.rerender('29c1299c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/project/DonutChart.vue"
export default component.exports